// extracted by mini-css-extract-plugin
export default {"OrderList":"OrderList_OrderList__Dpnsp"};